export const LogoMinos = () => {
	return (
		<svg width='133' height='50' viewBox='0 0 133 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M41.3455 40.088L39.5131 24.6563L33.3134 37.4881H30.0136L23.7814 24.6888L21.914 40.088H17.8467L20.6465 17.1241H24.1789L31.646 32.9233L39.0781 17.1241H42.6104L45.4103 40.088H41.343H41.3455Z'
				fill='black'
			/>
			<path d='M49.3799 17.1241H53.4472V40.088H49.3799V17.1241Z' fill='black' />
			<path
				d='M75.5786 17.1241V40.088H71.8788L62.7143 24.6238V40.088H58.647V17.1241H62.4793L71.5113 32.4559V17.1241H75.5786Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M90.9779 16.8591C84.4132 16.8591 79.3135 22.1239 79.3135 28.6236C79.3135 35.1232 84.4457 40.423 90.9779 40.423C97.5101 40.423 102.642 35.1207 102.642 28.6236C102.642 22.1264 97.5426 16.8591 90.9779 16.8591ZM90.9454 20.659C95.3452 20.659 98.5775 24.2238 98.5775 28.6236C98.5775 33.0208 95.3102 36.5882 90.9454 36.5882C86.5806 36.5882 83.4133 33.0208 83.4133 28.6236C83.4133 24.2263 86.5456 20.659 90.9454 20.659Z'
				fill='black'
			/>
			<path
				d='M105.047 33.3883H109.08C109.112 35.1557 110.812 36.7881 113.347 36.7881C115.679 36.7881 117.179 35.4557 117.179 33.6558C117.179 32.0559 115.812 31.1234 113.879 30.5885L111.012 29.7885C106.08 28.5211 105.212 25.5562 105.212 23.5563C105.212 19.489 108.78 16.8566 113.012 16.8566C117.244 16.8566 120.512 19.4565 120.512 23.7563H116.479C116.479 21.8564 115.047 20.489 112.912 20.489C110.945 20.489 109.312 21.6889 109.312 23.4888C109.312 24.1213 109.512 25.4887 112.145 26.1562L114.877 26.8886C118.477 27.8886 121.244 29.821 121.244 33.4883C121.244 37.6881 117.744 40.4205 113.245 40.4205C108.345 40.4205 105.045 37.2531 105.045 33.3883H105.047Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M122.329 2.21489L130.059 9.997C131.153 11.3069 131.816 12.9944 131.816 14.8318V42.4454C131.816 46.6102 128.426 50 124.261 50H14.8293C12.9919 50 11.3069 49.3375 9.9945 48.2426L2.21239 40.5105C0.784961 39.0855 0 37.1881 0 35.1682V7.55712C0 3.39233 3.38983 0.00249987 7.55462 0H116.987C119.004 0 120.901 0.787461 122.329 2.21489ZM124.259 48.6401C127.676 48.6401 130.453 45.8602 130.453 42.4454L130.456 42.4429V14.8318C130.456 11.4144 127.676 8.63707 124.261 8.63707H14.8293C11.4144 8.63707 8.63707 11.4169 8.63707 14.8318V42.4454C8.63707 45.8627 11.4144 48.6401 14.8293 48.6401H124.259Z'
				fill='black'
			/>
		</svg>
	);
};

export const EmailIcon = ({ className = '' }: { className: string }) => {
	return (
		<svg
			className={`${className} transition-colors duration-300 ease-out group-hover:transition-colors group-hover:ease-in`}
			fill='currentColor'
			width='24'
			height='24'
			viewBox='0 0 22 23'
			aria-hidden
			pointerEvents='visibilePainted'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11 22.043C17.0751 22.043 22 17.1181 22 11.043C22 4.96784 17.0751 0.0429688 11 0.0429688C4.92487 0.0429688 0 4.96784 0 11.043C0 17.1181 4.92487 22.043 11 22.043ZM15.5539 6.60547H5.75295C5.41102 6.60547 5.14814 6.71713 4.96398 6.94021C4.77968 7.1634 4.68767 7.44252 4.68767 7.77726C4.68767 8.04764 4.80977 8.34061 5.05384 8.65625C5.29792 8.97176 5.55763 9.21958 5.83286 9.39984C5.98374 9.50293 6.43875 9.80882 7.19788 10.3174C7.60768 10.592 7.96406 10.8314 8.27031 11.0379C8.53134 11.2138 8.75647 11.3662 8.94233 11.4926C8.96291 11.5065 8.99484 11.5286 9.03703 11.5578L9.04177 11.561L9.22538 11.689C9.36963 11.7899 9.48947 11.8714 9.58492 11.9337C9.68024 11.996 9.79572 12.0657 9.9312 12.143C10.0666 12.2201 10.1943 12.2782 10.3141 12.3168C10.434 12.3554 10.5449 12.3748 10.647 12.3748H10.6536H10.6602C10.7623 12.3748 10.8733 12.3554 10.9932 12.3168C11.113 12.2782 11.2406 12.2203 11.376 12.143C11.5114 12.0657 11.6267 11.9959 11.7223 11.9337C11.8178 11.8714 11.9376 11.7899 12.0819 11.689C12.1567 11.6367 12.2174 11.5943 12.2654 11.5611C12.3099 11.5302 12.3435 11.5072 12.3649 11.4926C12.5097 11.3951 12.7354 11.2434 13.0387 11.0397C13.5907 10.6688 14.4037 10.1229 15.481 9.39984C15.8051 9.18099 16.0758 8.91689 16.2933 8.60792C16.5105 8.29894 16.6194 7.97485 16.6194 7.63573C16.6194 7.3524 16.5138 7.10996 16.3031 6.90803C16.0922 6.70636 15.8425 6.60547 15.5539 6.60547ZM5.36007 10.089C5.10711 9.92587 4.88279 9.73909 4.6875 9.5287V14.5025L7.66704 11.6211C7.07096 11.2187 6.30295 10.7086 5.36007 10.089ZM15.5539 15.6714C15.8221 15.6714 16.0545 15.5858 16.2521 15.4167L12.8716 12.1475C12.7905 12.2037 12.7119 12.2583 12.6376 12.3103C12.3846 12.4905 12.1793 12.6311 12.0216 12.7319C11.864 12.8329 11.6543 12.9359 11.3925 13.041C11.1305 13.1463 10.8864 13.1987 10.66 13.1987H10.6533H10.6467C10.4203 13.1987 10.1762 13.1463 9.91422 13.041C9.65225 12.9359 9.44251 12.8329 9.28502 12.7319C9.12738 12.6311 8.92216 12.4905 8.66905 12.3103C8.59852 12.2602 8.5203 12.2054 8.43572 12.1467L5.0546 15.4167C5.25214 15.5858 5.48469 15.6714 5.75288 15.6714H15.5539ZM13.641 11.6223C14.2758 11.1936 15.0466 10.6826 15.9535 10.089C16.2064 9.92151 16.4284 9.73485 16.6193 9.5287V14.5026L13.641 11.6223Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowBtn = ({
	className = '',
	width = '22',
}: {
	className?: string;
	width?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={`transition-colors duration-300 ease-in-out group-hover:transition-colors ${className}`}
			fill='currentColor'
			aria-hidden
			width={width}
			height='18'
			viewBox='0 0 22 18'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21.4142 8.88061L13 0.4664L11.5858 1.88061L17.5857 7.88046H0V9.88046H17.586L11.5858 15.8806L13 17.2948L21.4142 8.88061Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowLeft = () => {
	return (
		<svg
			className='size-2.5 rtl:rotate-180'
			aria-hidden='true'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			viewBox='0 0 6 10'
		>
			<path
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='2'
				d='M5 1 1 5l4 4'
			/>
		</svg>
	);
};

export const ArrowCarret = ({
	className = '',
	width = '15',
}: {
	className?: string;
	width?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height='11'
			viewBox='0 0 5 11'
			fill='none'
			aria-hidden
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 5.04785L-4.37114e-07 0.0478518L0 10.0479L5 5.04785Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PersonIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M13.646 10.7155C14.6264 9.94415 15.342 8.88642 15.6933 7.68944C16.0445 6.49246 16.014 5.21576 15.6058 4.03696C15.1977 2.85817 14.4323 1.83589 13.4161 1.11235C12.3999 0.388815 11.1835 0 9.93603 0C8.68858 0 7.47215 0.388815 6.45596 1.11235C5.43978 1.83589 4.67438 2.85817 4.26624 4.03696C3.85811 5.21576 3.82754 6.49246 4.17879 7.68944C4.53004 8.88642 5.24564 9.94415 6.22603 10.7155C4.54611 11.3885 3.08032 12.5048 1.98492 13.9454C0.88953 15.386 0.205595 17.0968 0.00603184 18.8955C-0.00841357 19.0268 0.00314838 19.1597 0.0400573 19.2866C0.0769662 19.4134 0.138499 19.5317 0.221143 19.6348C0.388051 19.843 0.630815 19.9763 0.896032 20.0055C1.16125 20.0347 1.42719 19.9573 1.63536 19.7904C1.84352 19.6235 1.97686 19.3807 2.00603 19.1155C2.22562 17.1607 3.15772 15.3553 4.62425 14.0443C6.09078 12.7333 7.98893 12.0085 9.95603 12.0085C11.9231 12.0085 13.8213 12.7333 15.2878 14.0443C16.7543 15.3553 17.6864 17.1607 17.906 19.1155C17.9332 19.3612 18.0505 19.5882 18.2351 19.7525C18.4198 19.9169 18.6588 20.007 18.906 20.0055H19.016C19.2782 19.9753 19.5178 19.8428 19.6826 19.6367C19.8474 19.4307 19.9241 19.1679 19.896 18.9055C19.6955 17.1017 19.0079 15.3865 17.9069 13.9437C16.8059 12.5009 15.3329 11.385 13.646 10.7155ZM9.93603 10.0055C9.14491 10.0055 8.37155 9.7709 7.71375 9.33137C7.05595 8.89185 6.54326 8.26713 6.24051 7.53623C5.93776 6.80533 5.85855 6.00106 6.01289 5.22513C6.16723 4.44921 6.54819 3.73648 7.1076 3.17707C7.66701 2.61766 8.37975 2.2367 9.15567 2.08235C9.93159 1.92801 10.7359 2.00723 11.4668 2.30998C12.1977 2.61273 12.8224 3.12542 13.2619 3.78321C13.7014 4.44101 13.936 5.21437 13.936 6.0055C13.936 7.06636 13.5146 8.08378 12.7645 8.83392C12.0143 9.58407 10.9969 10.0055 9.93603 10.0055Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PersonIconFilled = ({
	className = '',
	width = '16',
	height = '16',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M8.97186 8.98182C11.484 8.98182 13.6372 6.90909 13.6372 4.49091C13.6372 2.07273 11.484 0 8.97186 0C6.45974 0 4.30649 2.07273 4.30649 4.49091C4.30649 6.90909 6.45974 8.98182 8.97186 8.98182ZM15.7905 13.6455C11.1251 10.0182 4.30649 10.7091 0.538311 15.2C0.179437 15.7182 0 16.2364 0 16.7545C0 17.9636 1.07662 19 2.33268 19H15.611C16.5082 19 17.4054 18.4818 17.7643 17.7909C18.1231 17.1 18.1231 16.0636 17.4054 15.3727C16.8671 14.6818 16.3288 14.1636 15.7905 13.6455Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const LocalizationIcon = ({
	className = '',
	width = '16',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 13.4 7.05 19.5 7.35 19.76C7.53113 19.9149 7.76165 20.0001 8 20.0001C8.23835 20.0001 8.46887 19.9149 8.65 19.76C9 19.5 16 13.4 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 17.65C5.87 15.65 2 11.34 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8C14 11.34 10.13 15.66 8 17.65ZM8 4C7.20887 4 6.43552 4.2346 5.77772 4.67412C5.11992 5.11365 4.60723 5.73836 4.30448 6.46927C4.00173 7.20017 3.92252 8.00444 4.07686 8.78036C4.2312 9.55628 4.61216 10.269 5.17157 10.8284C5.73098 11.3878 6.44371 11.7688 7.21964 11.9231C7.99556 12.0775 8.79983 11.9983 9.53073 11.6955C10.2616 11.3928 10.8864 10.8801 11.3259 10.2223C11.7654 9.56448 12 8.79113 12 8C12 6.93913 11.5786 5.92172 10.8284 5.17157C10.0783 4.42143 9.06087 4 8 4ZM8 10C7.60444 10 7.21776 9.8827 6.88886 9.66294C6.55996 9.44318 6.30362 9.13082 6.15224 8.76537C6.00087 8.39991 5.96126 7.99778 6.03843 7.60982C6.1156 7.22186 6.30608 6.86549 6.58579 6.58579C6.86549 6.30608 7.22186 6.1156 7.60982 6.03843C7.99778 5.96126 8.39991 6.00087 8.76537 6.15224C9.13082 6.30362 9.44318 6.55996 9.66294 6.88886C9.8827 7.21776 10 7.60444 10 8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const LocalizationIconFilled = ({
	className = '',
	width = '14',
	height = '16',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 13.4 7.05 19.5 7.35 19.76C7.53113 19.9149 7.76165 20.0001 8 20.0001C8.23835 20.0001 8.46887 19.9149 8.65 19.76C9 19.5 16 13.4 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 10C7.60444 10 7.21776 9.8827 6.88886 9.66294C6.55996 9.44318 6.30362 9.13082 6.15224 8.76537C6.00087 8.39991 5.96126 7.99778 6.03843 7.60982C6.1156 7.22186 6.30608 6.86549 6.58579 6.58579C6.86549 6.30608 7.22186 6.1156 7.60982 6.03843C7.99778 5.96126 8.39991 6.00087 8.76537 6.15224C9.13082 6.30362 9.44318 6.55996 9.66294 6.88886C9.8827 7.21776 10 7.60444 10 8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const TagIcon = ({
	className = '',
	width = '21',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 15 15`}
			fill='currentColor'
		>
			<path
				d='M6.25002 4.13625C5.95334 4.13625 5.66333 4.22422 5.41666 4.38904C5.16999 4.55386 4.97773 4.78813 4.8642 5.06222C4.75067 5.33631 4.72096 5.63791 4.77884 5.92888C4.83672 6.21985 4.97958 6.48713 5.18936 6.69691C5.39914 6.90669 5.66641 7.04955 5.95738 7.10743C6.24835 7.1653 6.54995 7.1356 6.82404 7.02207C7.09813 6.90854 7.3324 6.71628 7.49722 6.4696C7.66204 6.22293 7.75002 5.93292 7.75002 5.63625C7.75002 5.23842 7.59198 4.85689 7.31068 4.57559C7.02937 4.29428 6.64784 4.13625 6.25002 4.13625ZM19.87 8.84625L11.46 0.426247C11.3666 0.333566 11.2558 0.260241 11.1339 0.210476C11.0121 0.160711 10.8816 0.135486 10.75 0.136247H1.75002C1.4848 0.136247 1.23045 0.241604 1.04291 0.42914C0.855374 0.616677 0.750017 0.871031 0.750017 1.13625V10.1362C0.749256 10.2679 0.774481 10.3983 0.824245 10.5202C0.87401 10.642 0.947335 10.7528 1.04002 10.8462L9.46002 19.2562C10.0225 19.8181 10.785 20.1336 11.58 20.1336C12.375 20.1336 13.1375 19.8181 13.7 19.2562L19.87 13.1362C20.4318 12.5737 20.7474 11.8113 20.7474 11.0162C20.7474 10.2212 20.4318 9.45875 19.87 8.89625V8.84625ZM18.46 11.6662L12.28 17.8362C12.0927 18.0225 11.8392 18.127 11.575 18.127C11.3108 18.127 11.0574 18.0225 10.87 17.8362L2.75002 9.72625V2.13625H10.34L18.46 10.2562C18.5527 10.3497 18.626 10.4605 18.6758 10.5823C18.7256 10.7042 18.7508 10.8346 18.75 10.9662C18.7489 11.2286 18.6448 11.48 18.46 11.6662Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const TagIconFilled = ({
	className = '',
	width = '15',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 15 15`}
			fill='currentColor'
		>
			<path
				d='M3.5 2.07025C3.20333 2.07025 2.91332 2.15823 2.66664 2.32305C2.41997 2.48787 2.22771 2.72214 2.11418 2.99623C2.00065 3.27032 1.97094 3.57192 2.02882 3.86289C2.0867 4.15386 2.22956 4.42113 2.43934 4.63091C2.64912 4.84069 2.91639 4.98355 3.20736 5.04143C3.49834 5.09931 3.79994 5.0696 4.07403 4.95607C4.34811 4.84254 4.58238 4.65028 4.7472 4.40361C4.91203 4.15693 5 3.86692 5 3.57025C5 3.17243 4.84196 2.7909 4.56066 2.50959C4.27936 2.22829 3.89782 2.07025 3.5 2.07025ZM15.71 9.60025L9.53 15.7703C9.34264 15.9565 9.08919 16.061 8.825 16.061C8.56081 16.061 8.30736 15.9565 8.12 15.7703L0.293329 7.95322C0.105526 7.76565 0 7.51111 0 7.24568V1.07025C0 0.517967 0.447715 0.0702515 1 0.0702515H7.17579C7.441 0.0702515 7.69536 0.175608 7.88289 0.363145L15.71 8.19025C15.8027 8.28369 15.876 8.39451 15.9258 8.51635C15.9755 8.63818 16.0008 8.76865 16 8.90025C15.9989 9.16259 15.8947 9.41399 15.71 9.60025Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const DateIcon = ({
	className = '',
	width = '20',
	height = '21',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
		>
			<path
				d='M17 2H15V1C15 0.734784 14.8946 0.48043 14.7071 0.292893C14.5196 0.105357 14.2652 0 14 0C13.7348 0 13.4804 0.105357 13.2929 0.292893C13.1054 0.48043 13 0.734784 13 1V2H7V1C7 0.734784 6.89464 0.48043 6.70711 0.292893C6.51957 0.105357 6.26522 0 6 0C5.73478 0 5.48043 0.105357 5.29289 0.292893C5.10536 0.48043 5 0.734784 5 1V2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.316071 3.44129 0 4.20435 0 5V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7956 2 17 2ZM18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V10H18V17ZM18 8H2V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H5V5C5 5.26522 5.10536 5.51957 5.29289 5.70711C5.48043 5.89464 5.73478 6 6 6C6.26522 6 6.51957 5.89464 6.70711 5.70711C6.89464 5.51957 7 5.26522 7 5V4H13V5C13 5.26522 13.1054 5.51957 13.2929 5.70711C13.4804 5.89464 13.7348 6 14 6C14.2652 6 14.5196 5.89464 14.7071 5.70711C14.8946 5.51957 15 5.26522 15 5V4H17C17.2652 4 17.5196 4.10536 17.7071 4.29289C17.8946 4.48043 18 4.73478 18 5V8Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const DateIconFilled = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
		>
			<path
				d='M0 17C0 18.7 1.3 20 3 20H17C18.7 20 20 18.7 20 17V9H0V17ZM17 2H15V1C15 0.4 14.6 0 14 0C13.4 0 13 0.4 13 1V2H7V1C7 0.4 6.6 0 6 0C5.4 0 5 0.4 5 1V2H3C1.3 2 0 3.3 0 5V7H20V5C20 3.3 18.7 2 17 2Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PriceIcon = ({
	className = '',
	width = '20',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
		>
			<path
				d='M7 5.50159C6.73478 5.50159 6.48043 5.60694 6.29289 5.79448C6.10536 5.98202 6 6.23637 6 6.50159V8.50159C6 8.7668 6.10536 9.02116 6.29289 9.20869C6.48043 9.39623 6.73478 9.50159 7 9.50159C7.26522 9.50159 7.51957 9.39623 7.70711 9.20869C7.89464 9.02116 8 8.7668 8 8.50159V6.50159C8 6.23637 7.89464 5.98202 7.70711 5.79448C7.51957 5.60694 7.26522 5.50159 7 5.50159ZM19 6.50159C19.2652 6.50159 19.5196 6.39623 19.7071 6.20869C19.8946 6.02116 20 5.7668 20 5.50159V1.50159C20 1.23637 19.8946 0.982017 19.7071 0.79448C19.5196 0.606944 19.2652 0.501587 19 0.501587H1C0.734784 0.501587 0.48043 0.606944 0.292893 0.79448C0.105357 0.982017 0 1.23637 0 1.50159V5.50159C0 5.7668 0.105357 6.02116 0.292893 6.20869C0.48043 6.39623 0.734784 6.50159 1 6.50159C1.26522 6.50159 1.51957 6.60694 1.70711 6.79448C1.89464 6.98202 2 7.23637 2 7.50159C2 7.7668 1.89464 8.02116 1.70711 8.20869C1.51957 8.39623 1.26522 8.50159 1 8.50159C0.734784 8.50159 0.48043 8.60694 0.292893 8.79448C0.105357 8.98202 0 9.23637 0 9.50159V13.5016C0 13.7668 0.105357 14.0212 0.292893 14.2087C0.48043 14.3962 0.734784 14.5016 1 14.5016H19C19.2652 14.5016 19.5196 14.3962 19.7071 14.2087C19.8946 14.0212 20 13.7668 20 13.5016V9.50159C20 9.23637 19.8946 8.98202 19.7071 8.79448C19.5196 8.60694 19.2652 8.50159 19 8.50159C18.7348 8.50159 18.4804 8.39623 18.2929 8.20869C18.1054 8.02116 18 7.7668 18 7.50159C18 7.23637 18.1054 6.98202 18.2929 6.79448C18.4804 6.60694 18.7348 6.50159 19 6.50159ZM18 4.68159C17.4208 4.89179 16.9205 5.27522 16.5668 5.77975C16.2132 6.28429 16.0235 6.88547 16.0235 7.50159C16.0235 8.11771 16.2132 8.71889 16.5668 9.22342C16.9205 9.72796 17.4208 10.1114 18 10.3216V12.5016H8C8 12.2364 7.89464 11.982 7.70711 11.7945C7.51957 11.6069 7.26522 11.5016 7 11.5016C6.73478 11.5016 6.48043 11.6069 6.29289 11.7945C6.10536 11.982 6 12.2364 6 12.5016H2V10.3216C2.57915 10.1114 3.07954 9.72796 3.43316 9.22342C3.78678 8.71889 3.97648 8.11771 3.97648 7.50159C3.97648 6.88547 3.78678 6.28429 3.43316 5.77975C3.07954 5.27522 2.57915 4.89179 2 4.68159V2.50159H6C6 2.7668 6.10536 3.02116 6.29289 3.20869C6.48043 3.39623 6.73478 3.50159 7 3.50159C7.26522 3.50159 7.51957 3.39623 7.70711 3.20869C7.89464 3.02116 8 2.7668 8 2.50159H18V4.68159Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PriceIconFilled = ({
	className = '',
	width = '16',
	height = '16',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='currentColor'
		>
			<path
				d='M5 3.5C4.73478 3.5 4.48043 3.60536 4.29289 3.79289C4.10536 3.98043 4 4.23478 4 4.5V6.5C4 6.76522 4.10536 7.01957 4.29289 7.20711C4.48043 7.39464 4.73478 7.5 5 7.5C5.26522 7.5 5.51957 7.39464 5.70711 7.20711C5.89464 7.01957 6 6.76522 6 6.5V4.5C6 4.23478 5.89464 3.98043 5.70711 3.79289C5.51957 3.60536 5.26522 3.5 5 3.5ZM16 2.68C15.4208 2.8902 14.9205 3.27363 14.5668 3.77816C14.2132 4.2827 14.0235 4.88388 14.0235 5.5C14.0235 6.11612 14.2132 6.7173 14.5668 7.22184C14.9205 7.72637 15.4208 8.1098 16 8.32V10.5H6C6 10.2348 5.89464 9.98043 5.70711 9.79289C5.51957 9.60536 5.26522 9.5 5 9.5C4.73478 9.5 4.48043 9.60536 4.29289 9.79289C4.10536 9.98043 4 10.2348 4 10.5H0V8.32C0.579152 8.1098 1.07954 7.72637 1.43316 7.22184C1.78678 6.7173 1.97648 6.11612 1.97648 5.5C1.97648 4.88388 1.78678 4.2827 1.43316 3.77816C1.07954 3.27363 0.579152 2.8902 0 2.68V0.5H4C4 0.765216 4.10536 1.01957 4.29289 1.20711C4.48043 1.39464 4.73478 1.5 5 1.5C5.26522 1.5 5.51957 1.39464 5.70711 1.20711C5.89464 1.01957 6 0.765216 6 0.5H16V2.68Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowSmall = ({
	className = '',
	width = '15',
	height = '17',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 22 17'
			fill='currentColor'
			aria-hidden
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21.4142 8.41421L13 0L11.5858 1.41421L17.5857 7.41406H0V9.41406H17.586L11.5858 15.4142L13 16.8284L21.4142 8.41421Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowBig = ({
	className = '',
	width = '15',
}: {
	className?: string;
	width?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height='16'
			viewBox='0 0 40 16'
			fill='currentColor'
			aria-hidden
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M34.6787 6.36346L30.1376 1.97967L32.0524 0.15686L39.8214 7.65686L32.0524 15.1569L30.1376 13.3341L34.6786 8.95033L0.178622 8.95074L0.178589 6.36387L34.6787 6.36346Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ValidationIcon = ({
	className = '',
	width = '46',
	height = '46',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 46 47'
			fill='none'
			aria-hidden
		>
			<path
				d='M23 46.9487C10.3174 46.9487 0 36.6309 0 23.9487C0 11.2666 10.3174 0.94873 23 0.94873C35.6826 0.94873 46 11.2666 46 23.9487C46 36.6309 35.6826 46.9487 23 46.9487Z'
				fill='currentColor'
			/>
			<path
				d='M18.8281 34.606L8 23.7773L10.8281 20.9487L18.8281 28.9487L34.8281 12.9487L37.6562 15.7773L18.8281 34.606Z'
				fill='white'
			/>
		</svg>
	);
};

export const ErrorIcon = ({
	className = '',
	width = '12',
	height = '13',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 12 13'
			fill='none'
			aria-hidden
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 6.25635C0 9.56486 2.69149 12.2563 6 12.2563C9.30851 12.2563 12 9.56486 12 6.25635C12 2.94784 9.30851 0.256348 6 0.256348C2.69149 0.256348 0 2.94784 0 6.25635ZM7.04348 6.25634L8.86956 8.08243L7.82608 9.12591L6 7.29982L4.17391 9.12591L3.13043 8.08243L4.95652 6.25634L3.13043 4.43026L4.17391 3.38678L6 5.21287L7.82608 3.38678L8.86956 4.43026L7.04348 6.25634Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const BurgerIcon = ({
	className = '',
	width = '50',
	height = '22',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox='0 0 50 22'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<line x1='1' y1='1' x2='49' y2='1' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
			<line
				x1='1'
				y1='11'
				x2='49'
				y2='11'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
			<line
				x1='1'
				y1='21'
				x2='49'
				y2='21'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export const BurgerCloseIcon = ({
	className = '',
	width = '46',
	height = '27',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 46 27'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<line
				x1='2.71563'
				y1='1.13397'
				x2='44.2849'
				y2='25.134'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
			<line
				x1='1.71563'
				y1='25.134'
				x2='43.2849'
				y2='1.13397'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export const CloseIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 21 21'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.8618 8.81113L2.55069 0.5L0.86183 2.18886L9.17296 10.5L0.861816 18.8111L2.55068 20.5L10.8618 12.1889L18.8763 20.2034L20.5652 18.5145L12.5507 10.5L20.5652 2.48549L18.8763 0.796628L10.8618 8.81113Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const LoupeIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19.8336 18.2158L14.6588 13.0027C14.4645 12.8073 14.4451 12.5062 14.5954 12.2753C16.7171 9.02105 16.2222 4.54567 13.092 1.87256C10.08 -0.698844 5.49545 -0.610845 2.57719 2.06798C-0.772506 5.14281 -0.857077 10.3765 2.32462 13.5604C5.03774 16.2758 9.23714 16.6055 12.3211 14.5656C12.5525 14.4124 12.856 14.4324 13.0514 14.629L18.2148 19.8312C18.4382 20.0558 18.8005 20.0564 19.0245 19.8324L19.8325 19.0238C20.0554 18.8009 20.0559 18.4398 19.8336 18.2158ZM3.94061 11.9427C1.73262 9.73304 1.73262 6.13765 3.94061 3.92796C6.14859 1.71827 9.74114 1.7177 11.9491 3.92796C14.1571 6.13765 14.1571 9.73304 11.9491 11.9427C9.74114 14.1524 6.14859 14.1524 3.94061 11.9427Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const MenuChildIcon = ({
	className = '',
	width = '14',
	height = '9',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 14 9'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.99992 8.32819L0.292819 1.62108L1.70703 0.206865L6.99992 5.49976L12.2928 0.206866L13.707 1.62108L6.99992 8.32819Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const Wave = ({
	className = '',
	pathClassName = '',
}: {
	className?: string;
	pathClassName?: string;
}) => {
	return (
		<svg
			data-svg='wave'
			aria-hidden
			className={`${className}`}
			height='76'
			viewBox='0 0 1680 76'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			preserveAspectRatio='none'
		>
			<path
				d='M1680 33.2759V76H2.41822e-05C-3.01547e-05 3.78696 2.41936e-05 33.2759 2.41936e-05 33.2759C2.41936e-05 33.2759 74.9995 63.3647 187.999 63.3647C300.999 63.3647 318 33.2759 420 33.2759C522 33.2759 534.999 63.3647 630 63.3647C725.001 63.3647 736.501 13.7183 840 1.38188C943.499 -10.9545 968 63.3647 1050 63.3647C1132 63.3647 1145.5 33.2759 1260 33.2759C1374.5 33.2759 1378.5 55.5415 1470 63.3647C1561.5 71.1878 1680 33.2759 1680 33.2759Z'
				className={pathClassName}
			/>
		</svg>
	);
};

export const Bubble = ({
	className = '',
	pathClassName = '',
	position = 'left',
}: {
	className?: string;
	pathClassName?: string;
	position?: 'left' | 'right';
}) => {
	return (
		<svg
			data-svg={`circle-${position}`}
			aria-hidden='true'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 150 300'
			preserveAspectRatio='none'
			className={`${className} pointer-events-none`}
		>
			<g id='Calque_2' data-name='Calque 2'>
				<g id='Calque_1-2' data-name='Calque 1'>
					<path
						className={pathClassName}
						d='M118,148.45A148.86,148.86,0,0,1,.5,294V3A148.86,148.86,0,0,1,118,148.45Z'
					/>
					<rect fill='none' x='0.5' width='23' height='150' />
				</g>
			</g>
		</svg>
	);
};
